import {safeGetStore} from '../store/store';

const getActiveUser = () => {
    const store = safeGetStore();

    return store?.user?.user ?? null;
};

const getActivePerson = () => {
    const store = safeGetStore();

    return store?.user?.person ?? null;
};

const getActiveMembership = () => {
    const store = safeGetStore();

    return store?.user?.membership ?? null;
};

const isMembershipSet = () => {
    return getActiveMembership() !== null;
};

const getStoreData = () => {
    const store = safeGetStore();
    const currentProfileId = store?.user?.currentProfileID || null;
    const profiles = store?.user?.profiles || [];
    const membership = store?.user?.membership || null;

    return { store, currentProfileId, profiles, membership };
};

const getActiveProfile = () => {
    const { currentProfileId, profiles } = getStoreData();

    if (currentProfileId) {
        return profiles.find(profile => profile.id === currentProfileId) || null;
    }
    return null;
};

const getActiveAccount = () => {
    const activeProfile = getActiveProfile();
    return activeProfile ? activeProfile.account : null;
};

const getAccountMembershipNumber = () => {
    const { membership } = getStoreData();
    const account = getActiveAccount();

    return !membership || !account ? null : `${account.account_number}-${membership.membership_number}`;
};

// There are multiple places we are using an Identifier such as John Doe 1-1.
// Create this function to no longer continue concatenating them separately
const getAccountMembershipNumberPerson = () => {
    return `${getAccountMembershipNumber()} ${getActivePerson().first_name} ${getActivePerson().last_name}`
}

export {
    getActiveUser,
    getActivePerson,
    getActiveProfile,
    getActiveMembership,
    getActiveAccount,
    isMembershipSet,
    getAccountMembershipNumber,
    getAccountMembershipNumberPerson,
};
